import { render, staticRenderFns } from "./CourseApplicationForm.vue?vue&type=template&id=21c5d5b1&"
import script from "./CourseApplicationForm.vue?vue&type=script&lang=js&"
export * from "./CourseApplicationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports